import TableStats from '@campx-org/shared/src/components/Tables/common/TableStats'
import {
  StyledLimitBox,
  StyledLimitMenu,
  StyledPagination,
  StyledTableFooter,
} from '@campx-org/shared/src/components/Tables/common/styles'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { Box, MenuItem, Stack, Typography } from '@mui/material'
import { useState } from 'react'

interface PaginationFooterProps {
  page: number
  limit: number
  totalCount: number
  onPageChange: (page: number) => void
  onLimitChange: (limit: number) => void
}

export function PaginationFooter({
  page,
  limit,
  totalCount,
  onPageChange,
  onLimitChange,
}: PaginationFooterProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const totalPages = Math.ceil(totalCount / limit)

  return (
    <StyledTableFooter>
      <TableStats limit={limit} page={page} totalCount={totalCount} />
      <Stack direction="row" gap={2} alignItems="center">
        <StyledPagination
          variant="outlined"
          shape="rounded"
          count={totalPages}
          page={page}
          onChange={(_e, newPage) => onPageChange(newPage)}
        />
      </Stack>
      <StyledLimitBox open={open}>
        <Box onClick={(e) => setAnchorEl(e.currentTarget)}>
          <Typography>{`${limit} / Page`}</Typography>
          <ExpandMore />
        </Box>
        <StyledLimitMenu
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
        >
          {[10, 20, 50, 100].map((size) => (
            <MenuItem
              key={size}
              value={size}
              onClick={() => {
                onLimitChange(size)
                setAnchorEl(null)
              }}
            >
              {size}
            </MenuItem>
          ))}
        </StyledLimitMenu>
      </StyledLimitBox>
    </StyledTableFooter>
  )
}
